import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#0f4efb',
        secondary: '#111111',
        accent: '#0f4efb',
        error: '#b3261e',
        warning: '#b7791f',
        info: '#0f4efb',
        success: '#111111'
      }
    }
  }
})
